import usePostList from '@/composables/post/postList'
import usePostApi from '@/composables/post/postApi'
import { ArrayHelper } from '@/helper/array'
import useConfiguration from '@/composables/configuration/configuration'

export default function usePostStatsManager() {
  const { fetchPostStats } = usePostApi()
  const { postList, findPostRoot } = usePostList()
  const { configuration } = useConfiguration()

  async function loadPostsStats() {
    const ids: number[] = []
    postList.forEach(postRoot => {
      if (postRoot.post && postRoot.post.postMeta.statsLoaded === false) {
        ids.push(postRoot.post.id)
      }
    })

    if (postList.length === 0) {
      return
    }
    ids.sort((a, b) => {
      return a - b
    })
    const idGroups = ArrayHelper.createGroups<number>(
      ids,
      configuration.bulkSize
    )

    idGroups.forEach(idGroup => {
      const { request, response } = fetchPostStats(idGroup)

      request().then(() => {
        if (response.value) {
          response.value.forEach(postStat => {
            const root = findPostRoot(postStat.id)

            if (root && root.post) {
              root.post.stats = postStat.stats
              root.post.postMeta.statsLoaded = true
            }
          })
        }
      })
    })
  }

  return {
    loadPostsStats,
  }
}
